import { auth } from "@Firebase/firebase";
import { DealerDashboardFilters } from "@Pages/DealersDashboard/DealersDashboard";

import axios from "axios";

export const getLenderDecisionsByStatus = async (  query?: DealerDashboardFilters) => {
  const token = await auth.currentUser?.getIdToken();
  const lenderId = auth.currentUser?.uid; // Assuming lenderId is the Firebase UID

  const { data } = await axios.get<{ result: { generalCounts: { status: { count: number} }; approvedFundedStatus: { fundedCount: number; notFundedCount: number,fundedByOther: number } } }>(
    `${process.env.REACT_APP_HTTP_URL}/lender-api/v1/lender_decisions_by_status`,
    {
      headers: {
        authorization: `Bearer ${token}`,
        lenderId: lenderId,
        query:
            query && Object.keys(query)?.length
              ? JSON.stringify(query)
              : undefined,
      },
     
    }
  );
  return data.result;
};